import { BaseService } from './base-service'
import { Observable } from 'rxjs'
import { CreditAPIConstant } from '@/api/constant/credit'
import { LoanRequest, LoanResponse } from '@/api/model/credit'
import { Page } from '@/api/model/base'

export class CreditService extends BaseService {
    protected creditConstant: CreditAPIConstant
    constructor() {
        super()
        this.creditConstant = new CreditAPIConstant()
    }

    queryLoanPage(data: LoanRequest): Observable<Page<LoanResponse>> {
        return this.request(this.creditConstant.queryLoanPage(data))
    }
}
